export const formatPhone = (v) => {
  const d = (v || "").replace(/\D/g, "");
  if (d.length < 10) return v;
  const t = d.slice(-10);
  return `0${t.slice(0, 3)} ${t.slice(3, 6)} ${t.slice(6, 8)} ${t.slice(8)}`;
};
